/**
 * 개발용 mock API. `pnpm dev:mock` 일 때만 뜬다 → ./entry.ts
 *
 * 화면을 먼저 만들고 백엔드와 계약을 맞추기 위한 것이다. handler 의 URL·본문이 곧
 * 백엔드에 요청할 API 계약 초안이고, 응답은 `@/types` 의 타입으로 쓴다.
 *
 * **모든 화면이 백엔드 없이 돈다.** 그러므로 백엔드에 구현된 endpoint 라 해도 handler 를
 * 지우지 않는다 — 지우면 그 화면만 mock 모드에서 죽는다. 잡히지 않은 API 요청은
 * 통과하지 않고 그 자리에서 실패한다 → ./entry.ts
 */
import { setupWorker } from "msw/browser";
import { assistantHandlers } from "./handlers/assistant";
import { attendanceHandlers } from "./handlers/attendance";
import { authHandlers } from "./handlers/auth";
import { dailyHandlers } from "./handlers/daily";
import { directoryHandlers } from "./handlers/directory";
import { projectHandlers } from "./handlers/projects";
import { settingsHandlers } from "./handlers/settings";
import { staffHandlers } from "./handlers/staff";
import { weeklyHandlers } from "./handlers/weekly";
import { weeklyTeamHandlers } from "./handlers/weeklyTeam";
import { documentsHandlers } from "./handlers/documents";
import { officeHandlers } from "./handlers/office";

export const worker = setupWorker(
  ...authHandlers,
  ...settingsHandlers,
  ...officeHandlers,
  ...directoryHandlers,
  ...documentsHandlers,
  ...attendanceHandlers,
  ...projectHandlers,
  ...weeklyHandlers,
  ...weeklyTeamHandlers,
  ...staffHandlers,
  ...dailyHandlers,
  ...assistantHandlers
);
